import store from '../store';

let timer = () => {};

export function pollAuthenticationExporation() {
  if(store.state.user === null || !window.$cookies.get('Authorization')) {
    return;
  }
    timer = window.setInterval(async() => {
      try {
        await store.dispatch('auth/getEcho');
      }
      catch(error) {
        await store.dispatch('auth/refreshToken');
      }
    }, 10000);
  //TODO: onko tarpeellista pollata Näin usein?
}


export function killTimer() {
  clearInterval(timer);
}
